/**
 * Урок для текущей страницы -- выбор макета (trainingContextLesson, М/training.js:105-121):
 * «Помощь» и пункт меню обучения открывают сценарий раздела, для прочих -- быстрое знакомство.
 * Разделы хранилищ в макете два: список (storages -- подключение источника) и карточка ресурса
 * (resource -- расследование); образцы -- отдельный раздел samples без своего урока.
 */

import { STORAGE_CATALOG_ROUTE, STORAGE_GROUPS } from '@/pages/DataStorages/groups';
import type { LessonId } from './catalog';

const BY_SECTION: readonly [prefix: string, lesson: LessonId][] = [
	['/overview', 'daily'],
	['/policies', 'policy'],
	['/llm-gate', 'ai'],
	['/data-map', 'map'],
	['/activity-log', 'investigation'],
	['/attack-paths', 'investigation'],
	['/integrations', 'integrations'],
	['/infrastructure-access', 'source'],
];

/** Списки раздела хранилищ: каталог и вкладки групп */
const STORAGE_LISTS: ReadonlySet<string> = new Set([
	STORAGE_CATALOG_ROUTE,
	...STORAGE_GROUPS.flatMap((group) => group.tabs.map((tab) => tab.route)),
]);

/** Образец данных хранилища: …/sample/:id */
const STORAGE_SAMPLE = /^\/data-storages\/.+\/sample\/[^/]+$/;

function within(pathname: string, prefix: string): boolean {
	return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

function storageLesson(pathname: string): LessonId {
	if (STORAGE_LISTS.has(pathname)) return 'source';
	if (STORAGE_SAMPLE.test(pathname)) return 'quick';
	return 'investigation';
}

export function contextLesson(pathname: string): LessonId {
	if (within(pathname, STORAGE_CATALOG_ROUTE)) return storageLesson(pathname);
	return BY_SECTION.find(([prefix]) => within(pathname, prefix))?.[1] ?? 'quick';
}
